import SvqForm from "../QueryForms/SvqForm";
import SnqForm from "../QueryForms/SnqForm";
import RqForm from "../QueryForms/RqForm";
import QdlForm from "../QueryForms/QdlForm";
import DqForm from "../QueryForms/DqForm";
import UqForm from "../QueryForms/UqForm";
import QvpForm from "../QueryForms/QvpForm";
import XqForm from "../QueryForms/XqForm";
import QnmForm from "../QueryForms/QnmForm";
import KqForm from "../QueryForms/KqForm";
import SqForm from "../QueryForms/SqForm";
import BqForm from "../QueryForms/BqForm";

export const propInSights = [
  {
    id: 1,
    fullName: "Y - Yes",
    name: "Y",
  },
  {
    id: 2,
    fullName: "N - No",
    name: "N",
  },
];
export const reasonCodes = [
  {
    id: 1,
    fullName: "T - Traffic Violation",
    name: "T",
  },
  {
    id: 2,
    fullName: "N - Narcotics",
    name: "N",
  },
  {
    id: 3,
    fullName: "F - Fraud",
    name: "F",
  },
  {
    id: 4,
    fullName: "V - Violent Crime",
    name: "V",
  },
  {
    id: 5,
    fullName: "S - Theft",
    name: "S",
  },
  {
    id: 6,
    fullName: "H - Humanitarian",
    name: "H",
  },
];

const purposeCodes = [
  {
    value: "A",
    name: "A - Administrative",
    description: "Administrative file maintenance.",
  },
  {
    value: "C",
    name: "C - Criminal justice",
    description:
      "For official duties in connection with the administration of criminal justice. The authorized uses of Purpose Code C in situations that are not part of a criminal justice investigation but are duties of the agency where a criminal record check is necessary to accomplish the agency's mission.",
  },
  {
    value: "D",
    name: "D - Civil/Criminal Courts",
    description:
      "Used when the III transaction is for use by officials of civil or criminal courts in domestic violence or stalking cases. Civil courts may be issued ORIs containing a D in the ninth position, at the discretion of the appropriate state CJIS Systems Officer (CSO) and the FBI's CJIS Division. ORIs ending in D are limited to QH and QR transactions for Purpose Code D.",
  },
  {
    value: "E",
    name: "E - Non-criminal justice employment/licensing",
    description:
      "This is not an NCIC purpose code - state purpose code for non-criminal justice employment/licensing",
  },
  {
    value: "F",
    name: "F - Firearms",
    description:
      "Used by criminal justice agencies for the purposes of (a) issuing firearms-related permits and explosives permits pursuant to state law, regulation, or local ordinance; (b) returning firearms to their lawful owners; and (c) enforcing federal and state laws prohibiting certain persons with criminal records from possessing firearms in circumstances in which firearms have been pawned.",
  },
  {
    value: "H",
    name: "H - Public housing",
    description:
      "Requests by authorized public housing authorities assigned an ORI. Only authorized use is for background checks on adult applicants for (or tenants of) public housing for purposes of applicant screening, lease enforcement, and eviction.",
  },
  {
    value: "I",
    name: "I - Interstate non-criminal justice background checks",
    description:
      "Interstate approved non-criminal justice licensing and employment background checks.",
  },
  {
    value: "J",
    name: "J - Criminal justice background check",
    description:
      "Used when the III transaction involves employment with a criminal justice agency or the screening of employees of other agencies over which the criminal justice agency is required to have management control. Such screening may include the use of III on friends, relatives, and associates of the employee or applicant, unless restricted or prohibited by state statute, state common law, or local ordinance. Criminal Justice Employment (Purpose Code J) has been separated from other Criminal Justice Purposes (Purpose Code C) due to the varying requirements of some state agencies participating in the III. Purpose Code J is used for initial background checks of agency personnel as well.",
  },
  {
    value: "R",
    name: "R - FBI NFF record requests",
    description:
      "Used only by the FBI in III record requests to NFF states when fingerprints are identified to a record maintained by an NFF participating state. State or local III queries that include Purpose Code R will be rejected as unauthorized.",
  },
  {
    value: "S",
    name: "S - Sensitive position investigation",
    description:
      "Used when investigating individuals for any of the following: (1) Access to classified information, (2) Assignment to or retention in sensitive national security duties, (3) Acceptance or retention in the armed forces. Appointment, retention, or assignment to a position of public trust or a critical or sensitive position while either employed by the government or performing a government contract.",
  },
  {
    value: "V",
    name: "V - Visa applications",
    description: "Visa applications initiated by US Department of State.",
  },
  {
    value: "X",
    name: "X - Caregiver background checks",
    description: "Caregiver background checks, exigent circumstances.",
  },
];

export function BottomHalf(props) {
  if (props.queryType === "SVQ - 28") {
    return (
      <SvqForm
        licenseTypes={props.licenseTypes}
        {...props}
      />
    );
  } else if (props.queryType === "SNQ - 27 Name/DOB") {
    return <SnqForm {...props} />;
  } else if (props.queryType === "RQ - VIN") {
    return <RqForm {...props} />;
  } else if (props.queryType === "QDL - 27 VT PID") {
    return <QdlForm {...props} />;
  } else if (props.queryType === "DQ - 27 OOS PID") {
    return <DqForm {...props} />;
  } else if (props.queryType === "UQ - 27 Canadian") {
    return (
      <UqForm
        reasonCodes={reasonCodes}
        propInSights={propInSights}
        {...props}
      />
    );
  } else if (props.queryType === "QVP - Registered 28 by PID") {
    return <QvpForm {...props} />;
  } else if (props.queryType === "XQ - 28 Canadian") {
    return (
      <XqForm
        reasonCodes={reasonCodes}
        propInSights={propInSights}
        {...props}
      />
    );
  } else if (props.queryType === "QNM - 27 Name/DOB Soundex") {
    return <QnmForm {...props} />;
  } else if (props.queryType === "KQ - 27 Driver History") {
    return (
      <KqForm
        {...props}
        destination={props?.destination}
        reasonCodes={reasonCodes}
        purposeCodes={purposeCodes}
      />
    );
  } else if (props.queryType === "SQ - 28 Snowmobile") {
    return <SqForm {...props} />;
  } else if (props.queryType === "BQ - 28 Boat") {
    return <BqForm {...props} />;
  } else {
    return <div>Nothing here</div>;
  }
}

export default BottomHalf;
